import { useState } from "react";
import CustomeHeader from "../../components/Admin/Common/CustomeHeader";

import { MainContainer } from "../../StyledComponents/Dashboard";
import { ContentContainer } from "../../StyledComponents/RateManagement";

import ContentHead from "../../components/Admin/Common/ContentHead";
import MarkupDetails from "../../components/Admin/MarkupManagement/MarkupDetails";


function MarkupManagement() {

const [pageType, setPageType] = useState("table");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTab, setCurrentTab] = useState("1");
    const [pageSize, setPageSize] = useState(10);
    const [query_instance, setQueryInstance] = useState({});
    const [instance, setInstance] = useState({});
    const handleBackArrow = () => {
        setCurrentTab("2")
      }
    return (
        <MainContainer>
            <CustomeHeader title="Markup Management" description="Define markup rules to optimize the profits" />
            <ContentContainer>
            <ContentHead title="Markup Management" is_back_icon={false} />
            <MarkupDetails instance={instance} setQueryInstance={setQueryInstance} tab={currentTab} setPageType={setPageType} />
                </ContentContainer>
        </MainContainer>
    );
}

export default MarkupManagement